import React from 'react'
import { withTranslation } from 'react-i18next'
import { ArrowCircleRight } from "phosphor-react"
import PropTypes from 'prop-types'
import Skeleton from '../UI/Skeleton'

class AuthorMiniCard extends React.Component {
    constructor(props) {
        super(props)
        this.routeToCourse = this.routeToCourse.bind(this)
    }

    routeToCourse() {
        this.props.props.history.push(`/item/${this.props.id}`)
    }

    render() {
        const { t } = this.props
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <div className="course-element">
                            <div className="title md-font-size"><Skeleton /></div>
                            <div className="desc md-font-size"><Skeleton count={3} /></div>
                            <div className='mt-20px'>
                                <Skeleton width={150} />
                            </div>

                        </div>
                        :
                        <div className="course-element">
                            <div className="title md-font-size">{this.props.title}</div>
                            <div className="desc md-font-size" dangerouslySetInnerHTML={{ __html: this.props.desc }}></div>
                            <div className="btn news-btn" onClick={this.routeToCourse}>
                                <div className="news-btn-content">
                                    <ArrowCircleRight size={20} className="icon-primary" />
                                    <span className="news-btn-desc sm-font-size">{t('news-read-more')}</span>
                                </div>
                            </div>
                        </div>
                }
            </React.Fragment>
        )
    }
}

AuthorMiniCard.propTypes = {
    props: PropTypes.object,
    t: PropTypes.func,
    id: PropTypes.number,
    image: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    price: PropTypes.string,
    skeleton: PropTypes.bool,
}

export default withTranslation()(AuthorMiniCard)



// WEBPACK FOOTER //
// ./src/components/Authors/AuthorMiniCard.jsx